import React, { FunctionComponent, ReactNode } from "react";

import { Button } from "../../../../ui/Button/Button";
import { PopUpIcon } from "../../../../ui/icons/PopUpIcon";

type StockItemProps = {
  children: [ReactNode, ReactNode, ReactNode];
  link?: string;
};

export const StockRecord: FunctionComponent<StockItemProps> = ({
  children,
  link,
}) => {
  const [name, location, hint] = children;

  const className =
    "px-4 md:px-8 py-2 grid grid-cols-4 items-center gap-1 text-sm w-full";

  const content = (
    <>
      <span className="col-span-3 line-clamp-2 text-ink-2 font-light">
        {name}
      </span>
      <span className="text-xs flex items-center justify-between">
        <span className="grid">
          <span className="font-semibold">{location}</span>
          <span className="font-light text-ink-2 truncate whitespace-nowrap">
            {hint}
          </span>
        </span>
        {link && <PopUpIcon className="shrink-0 translate-x-2" />}
      </span>
    </>
  );

  if (link) {
    return (
      <Button
        aria-label="stockRecordLink"
        className="rounded-none flex w-full p-0"
        element="a"
        href={link}
        rel="noopener noreferrer"
        target="_blank"
      >
        <span className={className}>{content}</span>
      </Button>
    );
  }

  return <div className={className}>{content}</div>;
};
